import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  workflowBindingAll: [],
  workflowBinding: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const workflowBindingSlice = createSlice({
  name: "workflowBinding",
  initialState,
  reducers: {
    setWorkflowBindingAll: (state, action) => {
      state.workflowBindingAll = action.payload;
    },
    setWorkflowBinding: (state, action) => {
      state.workflowBinding = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setWorkflowBindingAll,
  setWorkflowBinding,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = workflowBindingSlice.actions;

export default workflowBindingSlice.reducer;
